import React from 'react'

import Base from '../_Base'

const RatingsDownActive = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M18 2a1 1 0 0 1 1 1v10a1 1 0 0 1-.314.728l-2.109 1.989A1.987 1.987 0 0 0 16 17.121V23a1 1 0 0 1-1 1h-2c-2.206 0-4-1.794-4-4v-3H4.618a1.987 1.987 0 0 1-1.789-1.106l-1.053-2.105a4.02 4.02 0 0 1 0-3.578L3 7.764V4c0-1.103.897-2 2-2h13zm4 .063a1 1 0 0 1 1 1V13a1 1 0 1 1-2 0V3.063a1 1 0 0 1 .883-.994L22 2.063z"
      fillRule="evenodd"
    />
  </Base>
)

export default RatingsDownActive
